import Dexie from 'dexie';
import { snapshotStoresSchema } from './types';

export async function getSnapshotDB(id: string) {
  const db = new Dexie(id);
  db.version(1).stores(snapshotStoresSchema);
  await db.open();

  return db;
}


export function createEntityDBName(entityId: string, activeWAL: number) {
  return `${entityId}-${activeWAL}`;
}


// interface GeneratePendingQueueKey {
//   key: PendingQueueItemKey;
//   dbSet: SheetsCommandsForUnsentDB;
// }
// export const generatePendingQueueKey = (
//   sequenceNumber: number,
//   userId: string,
//   set: PartialSheetManagementSet
// ): GeneratePendingQueueKey => {
//   const sheetIds: Set<string> = new Set();
//   const groupIds: Set<string> = new Set();

//   const dbSet: SheetsCommandsForUnsentDB = {
//     id: set.id,
//     creationCommands: set.creationCommands,
//     deletionCommands: set.deletionCommands,
//   };

//   getSheetAndGroupIdsFromCRUDEvents(
//     sheetIds,
//     groupIds,
//     set.creationCommands,
//     set.deletionCommands
//   );

//   if (set.groupCommands) {
//     if (!dbSet.groupCommands) dbSet.groupCommands = {};
//     for (let key of Object.keys(set.groupCommands ?? {})) {
//       dbSet.groupCommands[key] = set.groupCommands?.get(key)!;
//       groupIds.add(key);
//     }
//   }

//   if (set.sheetCommands) {
//     if (!dbSet.sheetCommands) dbSet.sheetCommands = {};

//     for (let key of Object.keys(set.sheetCommands ?? {})) {
//       dbSet.sheetCommands[key] = set.sheetCommands?.get(key)!;

//       sheetIds.add(key);
//     }
//   }

//   for (let key of Object.keys(set.sheetChanges ?? {})) {
//     sheetIds.add(key);
//   }

//   return {
//     key: [sequenceNumber, userId, Array.from(sheetIds), Array.from(groupIds)],
//     dbSet,
//   };
// };

// const getSheetAndGroupIdsFromCRUDEvents = (
//   sheetIds: Set<string>,
//   groupIds: Set<string>,
//   creationCommands: SheetsCommandsForUnsentDB['creationCommands'],
//   deletionCommands: SheetsCommandsForUnsentDB['deletionCommands']
// ) => {
//   for (const command of creationCommands ?? []) {
//     if (command.type === SheetCommandType.CreateSheet) {
//       sheetIds.add(command.sheet.id);
//     } else if (command.type === SheetGroupsCommandType.CreateGroup) {
//       groupIds.add(command.group.id);
//     }
//   }

//   for (const command of deletionCommands ?? []) {
//     if (command.type === SheetCommandType.DeleteSheet) {
//       sheetIds.add(command.sheetId);
//     } else if (command.type === SheetGroupsCommandType.DeleteGroup) {
//       groupIds.add(command.groupId);
//     }
//   }
// };

// export async function loadFeKey(
//   userId: string,
//   privateKey: CryptoKey,
//   key: string
// ): Promise<CryptoKey | undefined> {
//   try {
//     const encfeKey = await getUserEncFeKey(userId, key);
//     console.log("encFeKey", encfeKey)
//     const feKey = await decryptFeKeyWithPrivateKey(privateKey, encfeKey);
//     console.log("feKey", feKey)
//     return feKey;
//   } catch (err) {
//     console.log("err", err)
//     return undefined;
//   }
// }
